module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8750/img/design-manager.svg"